import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useStyles } from "styles/StyleDashboard";
import classNames from "classnames";
import PropTypes from "prop-types";

const formatMoney = (value) => {
  const num = parseFloat(String(value).replace(/,/g, ""));
  if (isNaN(num)) return "";
  return num.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const MoneyInput = ({ labelText, name, disabled, error: errorProp, ...rest }) => {
  const classes = useStyles();
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [display, setDisplay] = useState("");
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused && field.value !== "" && field.value != null) {
      setDisplay(formatMoney(field.value));
    }
  }, [field.value, focused]);

  const handleFocus = () => {
    setFocused(true);
    // Show raw number for editing
    const raw = parseFloat(String(field.value).replace(/,/g, ""));
    setDisplay(isNaN(raw) ? "" : String(raw));
  };

  const handleBlur = (e) => {
    setFocused(false);
    field.onBlur(e);
    const raw = parseFloat(String(display).replace(/,/g, ""));
    if (!isNaN(raw)) {
      setFieldValue(name, raw);
      setDisplay(formatMoney(raw));
    } else {
      setDisplay("");
    }
  };

  const handleChange = (e) => {
    const val = e.target.value.replace(/[^0-9.]/g, "");
    setDisplay(val);
    const num = parseFloat(val);
    if (!isNaN(num) && num >= 0) {
      setFieldValue(name, num);
    } else if (val === "") {
      setFieldValue(name, "");
    }
  };

  const hasError = errorProp || (meta.touched && meta.error);

  const labelClasses = classNames({
    [" " + classes.labelRootError]: hasError,
  });
  const underlineClasses = classNames({
    [classes.underlineError]: hasError,
    [classes.underline]: true,
  });

  return (
    <FormControl fullWidth className={classes.formControl}>
      {labelText && (
        <InputLabel className={classes.labelRoot + labelClasses} shrink>
          {labelText}
        </InputLabel>
      )}
      <Input
        classes={{ underline: underlineClasses }}
        value={display}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        startAdornment={<InputAdornment position="start">$</InputAdornment>}
        inputProps={{ inputMode: "decimal", style: { fontWeight: 600, fontSize: 16 } }}
        {...rest}
      />
      {meta.touched && meta.error && (
        <div className={classes.error}>{meta.error}</div>
      )}
    </FormControl>
  );
};

MoneyInput.propTypes = {
  labelText: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default MoneyInput;
